import { createWebHistory, createRouter } from "vue-router";

import pinia from "@/stores/pinia";
import { useAuthStore } from "@/stores/auth";

import Home from "@/views/Home.vue"; 
import Pos from "@/views/Pos.vue";  
import Brand from "@/views/page/Brand.vue"; 
import ProductCategory from "@/views/page/ProductCategory.vue"; 
import Product from "@/views/product/Product.vue"; 
import Notification from "@/views/Notifications.vue"; 
import Districts from "@/views/page/Districts.vue";  
import Company from "@/views/page/Company.vue";  
import Department from "@/views/page/Department.vue";  
import Outlet from "@/views/page/Outlet.vue";   
import Unit from "@/views/page/Unit.vue";  
import Role from "@/views/page/Role.vue";  
import RolePermission from "@/views/page/RolePermission.vue";  
import User from "@/views/page/User.vue";  
import Login from "@/views/page/Login.vue";  
import AppLogin from "@/views/page/LoginFromApp.vue";  
import Warehouse from "@/views/page/Warehouse.vue";  
import Customer from "@/views/page/Customer.vue";  
import CustomerLedger from "@/views/page/CustomerLedger.vue";  
import SupplierType from "@/views/page/SupplierType.vue";   
import CustomerGroup from "@/views/page/CustomerGroup.vue";   
import Supplier from "@/views/page/Supplier.vue";  
import PurchaseOrder from "@/views/purchase/PurchaseOrder.vue";  
import PurchaseOrderEdit from "@/views/purchase/PurchaseOrderEdit.vue";  
import PurchaseOrderList from "@/views/purchase/PurchaseOrderList.vue";  
import PurchaseReceive from "@/views/purchase/PurchaseReceive.vue";  
import PurchaseReceiveWarehouse from "@/views/purchase/WarehousePurchaseReceive.vue";  
import PurchaseReceiveList from "@/views/purchase/PurchaseReceiveList.vue";  
import PurchaseOrderApprovalList from "@/views/purchase/PurchaseOrderApprovalList.vue";  
import StorePurchaseRequisition from "@/views/purchase_requisition/StorePurchaseRequisition.vue";  
import StorePurchaseRequisitionEdit from "@/views/purchase_requisition/StorePurchaseRequisitionEdit.vue";  
import StoreRequisitionList from "@/views/purchase_requisition/StoreRequisitionList.vue";  
import StoreRequisitionApprovalList from "@/views/purchase_requisition/StoreRequisitionApprovalList.vue";  
import StoreRequisitionPurchaseOrder from "@/views/purchase_requisition/StoreRequisitionPurchaseOrder.vue";  
import StoreRequisitionPurchaseOrderEdit from "@/views/purchase_requisition/StoreRequisitionPurchaseOrderEdit.vue"; 
import Sizes from "@/views/page/Sizes.vue";  
import Colors from "@/views/page/Colors.vue";  
import Taxes from "@/views/page/Taxes.vue";  
import Attributes from "@/views/page/Attributes.vue";  
import AttributeValue from "@/views/page/AttributeValue.vue";  
import MobileWallet from "@/views/page/MobileWallet.vue";  
import ExpiryBoard from "@/views/expire_product/ExpiryBoard.vue";
import StockTransfer from "@/views/stock_transfer/StockTransfer.vue";
import StockTransferList from "@/views/stock_transfer/StockTransferList.vue";
import StockManagementList from "@/views/stock/StockManagement.vue";
import StockInOut from "@/views/stock/StockInOut.vue";
import Coupons from "@/views/page/Conpons.vue";  
import RewardsPoints from "@/views/rewards-points/RewardsPoints.vue";  
import PointsSettings from "@/views/rewards-points/PointsSettings.vue";  
import OrderTatalPoints from "@/views/rewards-points/OrderTatalPoints.vue";  
import InventoryBoard from "@/views/inventory/InventoryBoard.vue";
import SupplierLedger from "@/views/accounts/SupplierLedger.vue";
import Sales from "@/views/sales/PosSales.vue";
import BankAccountList from "@/views/account_settings/BankAccount.vue";
import DiscountSettings from "@/views/sales/DiscountSettings.vue";


import PurchaseReceiveBoard from "@/views/purchase/PurchaseReceiveBoard.vue";
import VendorPerformance from "@/views/purchase/VendorPerformance.vue";
import RFQList from "@/views/purchase/RFQ.vue";
import PermissionModule from "@/views/menu_and_permissions/ModuleOrMenu.vue";
import PermissionAction from "@/views/menu_and_permissions/PermissionAction.vue";
import AuditLogs from "@/views/reports/AuditLogs.vue";

// for test
import VoucherEdit from "@/views/accounts/VoucherEntryEdit.vue"; 



const authStore = useAuthStore(pinia);
const route_list = authStore.userRoutes;
var route_list_array = [];
for(let i=0; i<route_list.length; i++) {
  route_list_array.push({
    path: route_list[i].path,
    name: route_list[i].name,
    component: setComponent(route_list[i].component),
    icon_name: route_list[i].icon_name,
    meta: {
      module_name: route_list[i].module_name,
      parent_module: route_list[i].parent_module
    }
  });
}
// console.log('route_list', route_list);


function setComponent(component_name) {
  if (!component_name || component_name === 'null') {
    return Home;
  }
  // return () => import("@/views/"+component_name+".vue");
  return () => import(`@/views/${component_name}.vue`);
}

//custom route added 
route_list_array.push(
  {
    path: '/purchase/receive-board',
    name: 'purchase-receive-board',
    component: PurchaseReceiveBoard,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/permissions/module-or-menu',
    name: 'Module/Menu',
    component: PermissionModule,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/permissions/actions',
    name: 'Actions',
    component: PermissionAction,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/app-login',
    name: 'AppLogin',
    component: AppLogin,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/accounting/voucher-edit/:id',
    name: 'VoucherEdit',
    component: VoucherEdit,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/purchase/vendor-performance',
    name: 'vendor-performance',
    component: VendorPerformance,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/purchase/rfq',
    name: 'RFQ / CS',
    component: RFQList,
    icon_name: 'fas fa-file-contract',
  },
  {
    path: '/reports/audit-logs',
    name: 'audit-logs',
    component: AuditLogs,
    icon_name: 'fas fa-folder',
  },
  {
    path: '/settings/taxes',
    name: 'Taxes',
    component: Taxes,
    icon_name: 'fas fa-percent',
  },
  {
    path: '/settings/attributes',
    name: 'Attributes',
    component: Attributes,
    icon_name: 'fas fa-list',
  },
  {
    path: '/settings/attribute-values',
    name: 'Attribute Values',
    component: AttributeValue,
    icon_name: 'fas fa-list-alt',
  }
)

const routes = route_list_array;
const navigations = authStore.userNavigations;

let masterSettings = navigations.find(n => n.name.includes('Master') && n.name.includes('Setting'));
if (masterSettings) {
  if (!masterSettings.children) masterSettings.children = [];
  
  // Extract Sizes and Color from the current children to move them later
  const sizesItemIndex = masterSettings.children.findIndex(n => n.name === 'Sizes');
  let sizesItem = null;
  if (sizesItemIndex > -1) {
    sizesItem = masterSettings.children.splice(sizesItemIndex, 1)[0];
  }

  const colorItemIndex = masterSettings.children.findIndex(n => n.name === 'Color' || n.name === 'Colors');
  let colorItem = null;
  if (colorItemIndex > -1) {
    colorItem = masterSettings.children.splice(colorItemIndex, 1)[0];
  }


  // Push Sizes and Color after Attribute Values
  if (colorItem) {
    masterSettings.children.push(colorItem);
  }
  if (sizesItem) {
    masterSettings.children.push(sizesItem);
  }
}

let purchaseMenu = navigations.find(n => n.name === 'Purchase');
if (purchaseMenu) {
  if (!purchaseMenu.children) purchaseMenu.children = [];
  
  // Only push if it doesn't already exist
  const hasRfq = purchaseMenu.children.find(c => c.path === '/purchase/rfq');
  if (!hasRfq) {
    purchaseMenu.children.push({
      path: '/purchase/rfq',
      name: 'RFQ (Quotations)',
      icon_name: 'fas fa-file-contract',
      parent_module: purchaseMenu.name
    });
  }
}

const router = createRouter({
  history: createWebHistory(),
  routes,
  navigations
});

/**
 * Router guard for authentication
 * Redirects unauthenticated users to login page
 */
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore(pinia);
  
  // Check if user is authenticated using Pinia store
  const isAuthenticated = authStore.isAuthenticated;
  const token = authStore.token;

  // Public routes that don't require authentication
  const publicRoutes = ['Login', 'AppLogin'];
  
  if (!publicRoutes.includes(to.name) && !isAuthenticated) {
    // Redirect to Login if not authenticated
    next({ name: 'Login' });
  } else {
    // Allow access
    next();
  }
});

export default router;
